"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionConfig = exports.applyPersonalizationCopy = exports.getSitewideBannerData = exports.format = void 0;
/* eslint consistent-return: 0 */
const set_1 = __importDefault(require("lodash/set"));
const promotion_banner_module_scss_1 = __importDefault(require("./promotion-banner.module.scss"));
const ValuePropsPanel_1 = __importDefault(require("./subcomponents/ValuePropsPanel/ValuePropsPanel"));
const DiscountRangePanel_1 = __importDefault(require("./subcomponents/DiscountRangePanel/DiscountRangePanel"));
const promotions_configs_1 = require("../../promotions.configs");
const slots_json_1 = __importDefault(require("../../json-configs/slots.json"));
const format = (amount, digits = 2) => {
    if (!amount)
        return 0;
    const fixedAmount = amount % 1 === 0 ? amount : amount.toFixed(digits);
    return fixedAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.format = format;
const TRAFFIC_SOURCES = ['direct', 'organic', 'search', 'email', 'affiliate'];
const createTrafficMapper = (slotPrefix, defaultSlot) => (messaging) => {
    const defaultBanner = messaging.find(m => m.slot === defaultSlot) || null;
    return TRAFFIC_SOURCES.reduce((acc, source) => {
        const trafficSpecificSlot = `${slotPrefix}: ${source === 'direct' || source === 'organic'
            ? 'Direct / Organic Traffic'
            : `${source.charAt(0).toUpperCase() + source.slice(1)} Traffic`}`;
        acc[source] = messaging.find(m => m.slot === trafficSpecificSlot) || defaultBanner;
        return acc;
    }, {});
};
const mapTrafficToPromoBanner = createTrafficMapper(slots_json_1.default.sitewideBanner, slots_json_1.default.sitewideBanner);
const mapTrafficToPDPDefaultBanner = createTrafficMapper(slots_json_1.default.pdpDefault, slots_json_1.default.pdpDefault);
const mapTrafficToSaleBannerHeader = createTrafficMapper(slots_json_1.default.saleBannerHeading, slots_json_1.default.saleBannerHeading);
const mapTrafficToSaleBannerSubtitle = createTrafficMapper(slots_json_1.default.saleBannerSubtitle, slots_json_1.default.saleBannerSubtitle);
const applyPersonalizationCopy = (promotionData, marketChannel) => {
    const { sitewidePromo } = promotionData;
    // Early returns for cases where we don't apply overrides
    if (!(sitewidePromo === null || sitewidePromo === void 0 ? void 0 : sitewidePromo.promoProfile.isNoSale))
        return promotionData;
    if (sitewidePromo === null || sitewidePromo === void 0 ? void 0 : sitewidePromo.promoProfile.isCouponPromo)
        return promotionData;
    // Get all banner overrides
    const sitewideOverrides = mapTrafficToPromoBanner(sitewidePromo.messaging);
    const pdpOverrides = mapTrafficToPDPDefaultBanner(sitewidePromo.messaging);
    const headerOverrides = mapTrafficToSaleBannerHeader(sitewidePromo.messaging);
    const subtitleOverrides = mapTrafficToSaleBannerSubtitle(sitewidePromo.messaging);
    // Helper to create phone number link
    const createPhoneLink = (message, action, actionText) => {
        if (!(action === null || action === void 0 ? void 0 : action.includes('Phone #')))
            return message;
        const phoneNumber = action.split(':')[1].trim();
        return `${message} <a class="${promotion_banner_module_scss_1.default.phoneLink} promo-banner-phone" href="tel:+${phoneNumber}" data-selector="promo-banner-phone-cta">${actionText}</a> `;
    };
    // Get channel-specific messages with phone numbers if present
    const sitewideCopy = createPhoneLink(sitewideOverrides[marketChannel].messageDesktop, sitewideOverrides[marketChannel].action, sitewideOverrides[marketChannel].actionText);
    const pdpCopy = createPhoneLink(pdpOverrides[marketChannel].messageDesktop, pdpOverrides[marketChannel].action, pdpOverrides[marketChannel].actionText);
    const headerCopy = createPhoneLink(headerOverrides[marketChannel].messageDesktop, headerOverrides[marketChannel].action, headerOverrides[marketChannel].actionText);
    const subtitleCopy = createPhoneLink(subtitleOverrides[marketChannel].messageDesktop, subtitleOverrides[marketChannel].action, subtitleOverrides[marketChannel].actionText);
    // Update each section of the pagesMessaging
    const updateMessaging = (path, override, channelOverride) => {
        var _a;
        (0, set_1.default)(sitewidePromo.pagesMessaging, `${path}.messageDesktop`, override);
        // If the action is a phone number, null out action and actionText since it's in the message, otherwise use the channel action
        const isPhoneAction = (_a = channelOverride === null || channelOverride === void 0 ? void 0 : channelOverride.action) === null || _a === void 0 ? void 0 : _a.includes('Phone #');
        (0, set_1.default)(sitewidePromo.pagesMessaging, `${path}.action`, isPhoneAction ? null : (channelOverride === null || channelOverride === void 0 ? void 0 : channelOverride.action) || null);
        (0, set_1.default)(sitewidePromo.pagesMessaging, `${path}.actionText`, isPhoneAction ? null : (channelOverride === null || channelOverride === void 0 ? void 0 : channelOverride.actionText) || null);
    };
    // Update each section with appropriate messaging
    updateMessaging('sitewide', sitewideCopy, sitewideOverrides[marketChannel]);
    updateMessaging('pdp.default', pdpCopy, pdpOverrides[marketChannel]);
    updateMessaging('saleBannerHeading', headerCopy, headerOverrides[marketChannel]);
    updateMessaging('saleBannerSubtitle', subtitleCopy, subtitleOverrides[marketChannel]);
    return promotionData;
};
exports.applyPersonalizationCopy = applyPersonalizationCopy;
const getSitewideBannerData = (promotionData, vanityURLs) => {
    const { sitewidePromo = {}, prefixIds } = promotionData;
    const { pagesMessaging = {}, } = sitewidePromo;
    const messagingConfig = (pagesMessaging === null || pagesMessaging === void 0 ? void 0 : pagesMessaging.sitewide) || {};
    let theme = sitewidePromo === null || sitewidePromo === void 0 ? void 0 : sitewidePromo.theme;
    let { messageDesktop } = messagingConfig;
    const { action, actionText } = messagingConfig;
    let messagePrefixConfig = null;
    if (prefixIds) {
        messagePrefixConfig = vanityURLs[prefixIds[0]]
            ? vanityURLs[prefixIds[0]].banner
            : {
                id: null,
                prefix: null,
                isBold: null
            };
    }
    if (!messageDesktop) {
        const defaultMessage = `Free white glove delivery, free mattress removal & free setup.`;
        messageDesktop = defaultMessage;
        theme = 'brown';
    }
    if (!theme) {
        theme = 'brown';
    }
    return {
        messageDesktop,
        messagePrefixConfig,
        theme,
        action,
        actionText,
        sitewidePromo
    };
};
exports.getSitewideBannerData = getSitewideBannerData;
const getActionConfig = (action, sitewidePromo, theme = 'defaultPromo') => {
    switch (action) {
        case promotions_configs_1.actions.bmsmModal:
            return {
                Content: DiscountRangePanel_1.default,
                props: {
                    sitewidePromo,
                    isPopup: true
                },
                inPanel: false
            };
        case promotions_configs_1.actions.bmsmPanel:
            return {
                Content: DiscountRangePanel_1.default,
                props: {
                    sitewidePromo,
                    isPopup: false
                },
                inPanel: true,
                panelClassName: 'bmsmPanel'
            };
        case promotions_configs_1.actions.fixedDiscountPanel:
            return {
                Content: ValuePropsPanel_1.default,
                props: {
                    sitewidePromo,
                    isDefault: true
                },
                inPanel: true
            };
        case promotions_configs_1.actions.valuePropsPanel:
            return {
                Content: ValuePropsPanel_1.default,
                props: {
                    sitewidePromo,
                    isDefault: false
                },
                inPanel: true,
                panelClassName: theme
            };
        default:
            return null;
    }
};
exports.getActionConfig = getActionConfig;
//# sourceMappingURL=utils.js.map